import { createContext, useContext } from "react";
export class ApiError extends Error {
  constructor(
    message: string,
    public status: number,
  ) {
    super(message);
  }
}
export type Api = {
  request: <T = unknown>(path: string, options?: RequestInit) => Promise<T>;
  raw: (path: string, options?: RequestInit) => Promise<Response>;
};
export function makeApi(getToken: () => Promise<string | null>): Api {
  const raw = async (path: string, options: RequestInit = {}) => {
    const headers = new Headers(options.headers);
    const token = await getToken();
    if (token) headers.set("Authorization", `Bearer ${token}`);
    if (options.body && typeof options.body === "string")
      headers.set("Content-Type", "application/json");
    const res = await fetch(path, { ...options, headers });
    if (!res.ok) {
      let message = `Request failed (${res.status})`;
      try {
        message = ((await res.json()) as { error?: string }).error || message;
      } catch {
        /* non-JSON errors */
      }
      throw new ApiError(message, res.status);
    }
    return res;
  };
  return {
    raw,
    request: async <T,>(path: string, options: RequestInit = {}) =>
      (await raw(path, options)).json() as Promise<T>,
  };
}
export const ApiContext = createContext<Api>(makeApi(async () => null));
export const useApi = () => useContext(ApiContext);
export const post = (data: unknown = {}) => ({
  method: "POST",
  body: JSON.stringify(data),
});
export const patch = (data: unknown) => ({
  method: "PATCH",
  body: JSON.stringify(data),
});
